import React from 'react';
import { PageLeftItem } from "../../model/page";
import { TFunction } from "i18next";
import TemplateComponent, { TemplateComponentProps } from "../../containers/template_page/template_component/template_component";
import { CoursePageAttributes } from "../../containers/course_page/course_page";
import "./c88_box_title_image_cta.scss";
import { insertHtml } from '../../utils/dom';


interface C88BoxTitleImageCTAData extends PageLeftItem {
    title?: string;
    image?: string;
    cta_label?: string;
    cta_url?: string;
    image_alt?: string;
}

interface C88BoxTitleImageCTAProps extends TemplateComponentProps<C88BoxTitleImageCTAData> {
    courseAttributes: CoursePageAttributes;
}

class C88BoxTitleImageCTA extends TemplateComponent<C88BoxTitleImageCTAData, C88BoxTitleImageCTAProps> {

    static readonly ID: string = "box_title_image_cta";

    constructor(props: C88BoxTitleImageCTAProps) {
        super(props);
        this.requireInternationalization = true;
    }


    internationalComponentRender(data: C88BoxTitleImageCTAData, t: TFunction): React.ReactElement {

        let colorStyle = {};
        let backgroundStyle = {};
        if (this.props.courseAttributes.color_dipartimento) {
            colorStyle = { color: this.props.courseAttributes.color_dipartimento };
            backgroundStyle = { backgroundColor: this.props.courseAttributes.color_dipartimento };
        }

        return <div id="box-title-image-cta">
            <div className="component-title" style={colorStyle}>
                <p className="content editor-html" {...insertHtml(data.title!)} /></div>
            <div className="card">
                <div className="img-container">
                    <img className="image-card" src={data.image} alt={data.image_alt ? data.image_alt : data.title} />
                </div>
                <div className="footer" style={backgroundStyle}>
                    {data.cta_url && <a className="link" href={data.cta_url}>{data.cta_label}</a>}
                </div>
            </div>
        </div>;
    }
}

export default C88BoxTitleImageCTA;
